module.exports = __webpack_public_path__ + "static/fresh-2733d0377aad79a22006bebc3a8d1efa.jpg";